import Count               from "../fundamentals/count/Count";
import Pagination          from "../fundamentals/pagination/Pagination";
import CustomerSearchValue from "./criteria/CustomerSearchValue";
import CustomerSortType    from "./criteria/CustomerSortType";
import Customer            from "./Customer";
import CustomerId          from "./CustomerId";

class Customers {
  constructor(
    private readonly _list: Customer[] = [],
    private readonly _pagination: Pagination = new Pagination(),
    private readonly _count: Count = new Count(),
    private readonly _search: CustomerSearchValue = new CustomerSearchValue(),
    private readonly _sortType: CustomerSortType = CustomerSortType.NONE,
  ) {
  }

  public has(id: CustomerId): boolean {
    return !!this._list.find((customer: Customer) => customer.id.equals(id));
  }

  public add(customer: Customer): Customers {
    this._list.push(customer);
    return new Customers(this._list, this._pagination, this._count, this._search, this._sortType);
  }

  public remove(customer: Customer): Customers {
    const list: Customer[] = this._list.filter(value => value.id.notEquals(customer.id));
    return new Customers(list, this._pagination, this._count, this._search, this._sortType);
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): Customer[] {
    return this._list;
  }

  get pagination() {
    return this._pagination;
  }

  get count() {
    return this._count;
  }

  get search() {
    return this._search;
  }

  get sortType() {
    return this._sortType;
  }
}

export default Customers;
